import styled, { css } from 'styled-components';

export const ModalContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOpen', 'positionContent'].includes(prop),
})<{
  isOpen: boolean;
  positionContent: 'middle' | 'bottom';
}>`
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  transition: opacity var(--tr-fast);

  ${({ positionContent }) =>
    positionContent === 'bottom' &&
    css`
      align-items: flex-end;
    `}

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      pointer-events: all;
    `}
`;
export const Overlay = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(1px);
`;
